export default __webpack_public_path__ + "static/media/Saravia.2d42f413.jpg";